export const SET_APPLY_ERROR_MESSAGE = 'SET_APPLY_ERROR_MESSAGE';
